module.exports = __webpack_public_path__ + "static/img/equip-3.70605e20.png";